import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { TooltipContainer, UIDragListItem, UIDragListItemTypes, UITreeNode } from '@futrli/ui-components';
import { ChartOfAccountBulkFlatItem } from '@futrli-sdk/consolidations';

import { COACategory } from '../../../consolidation-context/types';

export interface AvailableAccountProps extends UITreeNode<COACategory | ChartOfAccountBulkFlatItem> {
  disabled?: boolean;
  onDragStart?: (event: React.DragEvent, id: string) => void;
}

export const AvailableAccount = memo(({ disabled, label, extra, onDragStart }: AvailableAccountProps) => {
  if (!extra) {
    return null;
  }

  const data = extra as ChartOfAccountBulkFlatItem;

  return (
    <UIDragListItem
      id={data.id}
      onDragStart={onDragStart}
      dimmed={disabled}
      draggable={!disabled}
      type={UIDragListItemTypes.ADD}
      style={{ margin: '0 0 6px -4px' }}
    >
      <TooltipContainer
        disableTooltip={!disabled}
        tooltipMessage={
          <FormattedMessage
            id="consolidation.please_create_an_elimination_group_first"
            defaultMessage="Please create an elimination group first"
          />
        }
        position="bottom"
      >
        <div>{label}</div>
      </TooltipContainer>
    </UIDragListItem>
  );
});
